module.exports = __webpack_public_path__ + "assets/img/zy4.592aee82.png";